var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(_vm.src),expression:"src"}],key:_vm.src,staticClass:"myImg",attrs:{"id":"myImg","alt":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }